import toast from "_common/toast";

const paytmScript = options => {
	const { moneyDonationId, token, amount /* moneyDonationKey,*/ }  = options;
	const { onScriptSuccess, onScriptFailure, onSuccess, onFailure } = options;

	const checkout = window.Paytm?.CheckoutJS || null;

	if ( !checkout )
		throw "Some error occurred, please try again after some time.";

	const config = {
		root : "",
		flow : "DEFAULT",
		data : {
			orderId   : "RD_" + moneyDonationId /* update order id */,
			token     : token /* update token value */,
			tokenType : "TXN_TOKEN",
			amount    : amount /* update amount */
		},
		merchant: {
			redirect: false
		},
		handler: {
			notifyMerchant    : () => {},
			transactionStatus : function ( paymentStatus ) {
				if ( paymentStatus.STATUS === "TXN_SUCCESS" ) {
					// Close the Paytm payment window
					onSuccess ();
					window.Paytm.CheckoutJS.close ();
				}
				if ( paymentStatus.RESPCODE === "01" ) {
					toast.success ( "Payment successful." );
					onSuccess ();
				} else if ( paymentStatus.RESPCODE === "400" || paymentStatus.RESPCODE === "402" ) {
					toast.success ( "Transaction status not confirmed yet." );
					onSuccess ();
				} else {
					toast.error ( "Payment Failed. Please try again." );

					onFailure ();

					return;
				}
			}
		}

	};

	checkout.init ( config )
		.then (
			function onSuccess () {
				onScriptSuccess ();
				checkout.invoke ();
			}
		)
		.catch (
			function onError ( error ) {
				onScriptFailure ( error );
			}
		);
};

export default paytmScript;
